import React, {Component} from 'react'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import FileUploader from "react-firebase-file-uploader"
import firebase from 'firebase'
import './Profile.css'

class EditProfile extends Component {
	state = {
		currentAbout: '',
		currentImage: '',
	}

	handleUploadSuccess = (filename) => {
		firebase.storage().ref('avatars').child(filename).getDownloadURL()
			.then(url => {
				//parse the url from this...it's adding extra info
				if (firebase.auth().currentUser) {
					firebase.database().ref("users/" + firebase.auth().currentUser.uid)
						.set({
							profile_photo: url,
						})
					this.getPictureFromFirebase()
				} else {
					alert("Cannot save photo_url to a User object because no user is logged in!")
				}
			})
	}

	updateAbout = () => {
		if (!this.state.currentAbout){
			this.props.setEditProfile(false);
			return;
		}
		if (firebase.auth().currentUser) {
			firebase.database().ref("users/" + firebase.auth().currentUser.uid)
				.set({
					profile_photo: this.state.currentImage,
					About: this.state.currentAbout,
				})

			this.props.setEditProfile(false);
		} else {
			alert("Cannot save photo_url to a User object because no user is logged in!")
		}
	}

	getPictureFromFirebase = () => {
		if (firebase.auth().currentUser) {
			firebase.database()
				.ref("users/" + firebase.auth().currentUser.uid)
				.once("value")
				.then((snapshot) => {
					const profile_url = (snapshot.val() && snapshot.val().profile_photo)
					this.setState({currentImage: profile_url})
				})
		}
	}

	getAboutFromFirebase = () => {
		if (firebase.auth().currentUser) {
			firebase.database()
				.ref("users/" + firebase.auth().currentUser.uid)
				.once("value")
				.then((snapshot) => {
					const aboutText = (snapshot.val() && snapshot.val().About)
					this.setState({currentAbout: aboutText})
				})
		}
	}

	onChangeTest = (e) => {
		this.setState({currentAbout: e.target.value})
	};

	componentDidMount = () => {
		this.getPictureFromFirebase();
		this.getAboutFromFirebase();
	}

	render() {
		return (
			<Grid container xs={12}>
				<Grid xs={12}>
					{/* <AppBar position="static">
						<Toolbar classes={{root: {backgroundColor: '#4f6e12'}}}>
							<h1>Edit Profile Page</h1>
						</Toolbar>
					</AppBar> */}
				</Grid>
				<br/><br/>
				<Grid item xs={12}>
					<Box display="flex">
						<Card>
							<CardContent>
								<div className="imageHolder">
									{this.state.currentImage ?
										(
											<React.Fragment>
												<div className="imageTitle">Current Image</div>
												<div>
													<img className="currentImage" src={this.state.currentImage}/>
												</div>
											</React.Fragment>
										) :
										(
											<React.Fragment>
												<div className="imageTitle">No Current Image</div>
												<div className="currentImage"></div>
											</React.Fragment>
										)
									}

									<div className="imageUpload">
										<label className="uploadButton">
											Select New Profile Picture
											<FileUploader
												hidden
												accept="image/*"
												name="image"
												storageRef={firebase.storage().ref("avatars")}
												onUploadSuccess={this.handleUploadSuccess}
											/>
										</label>
									</div>
								</div>
								<div className="aboutWrapper">
									<label className="aboutTextTitle">Current About Me Text:</label>
								</div>


								<textarea className="aboutTextArea" value={this.state.currentAbout} onChange={((e) => this.onChangeTest(e))}></textarea>
								<br/>
							</CardContent>
							<Button className="editButton" onClick={() => this.updateAbout()}>Save Profile</Button>
						</Card>
					</Box>
				</Grid>
				<Grid xs={8}>

				</Grid>
			</Grid>

		)
	}
}

export default EditProfile
